<template>
  <div class='h-toolbarBg' >
    <ejs-toolbar >
      <e-items>
        <e-item v-if='refreshBtn' prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("Alarm.refresh")' :click='notices' eventType='refresh'></e-item>
        <e-item v-if='exportBtn' prefixIcon='icon hero-icon hero-icon-export' :tooltipText='$t("Alarm.export")' :click='notices' eventType='export'></e-item>
        <!-- download align-bottom 导出全部 -->
        <e-item v-if='exportBtn' prefixIcon='icon hero-icon hero-icon-batch-export' :tooltipText='$t("Alarm.exportAll")' :click='notices' eventType='exportAll'></e-item>
        <e-item v-if='syncBtn' prefixIcon='icon hero-icon hero-icon-synchronize' :tooltipText='$t("Alarm.synchronize")' :click='notices' eventType='sync'></e-item>
        <e-item v-if='separatorLine'  type='Separator'></e-item>
        <e-item v-if='confirmBtn' prefixIcon='icon hero-icon hero-icon-confirm' :tooltipText='$t("Alarm.acknowledge")' :click='notices' eventType='confirm'></e-item>
        <e-item v-if='clearBtn' prefixIcon='icon hero-icon hero-icon-clear' :tooltipText='$t("Alarm.clear")' :click='notices' eventType='clear'></e-item>
        <e-item v-if='showDetailBtn' prefixIcon='icon hero-icon hero-icon-alarm-details' :tooltipText='$t("Alarm.alarmDetails")' :click='notices' eventType='showDetail'></e-item>
        <e-item v-if='statisticsBtn' prefixIcon='icon hero-icon hero-icon-statistics' :tooltipText='$t("Alarm.statistics")' :click='notices' eventType='statistics'></e-item>
        <e-item v-if='shieldBtn' prefixIcon='icon hero-icon hero-icon-shield' :tooltipText='$t("Alarm.shield")' :click='notices' eventType='shield'></e-item>
        <e-item v-if='filterBtn' :prefixIcon='fiterIcon' :tooltipText='$t("Alarm.filter")' :click='notices' eventType='filter'></e-item>
        <e-item v-if='subscritionBtn' :prefixIcon='subscritionIcon' :tooltipText='$t("Alarm.alertSubscription")' :click='subscritionFunc'></e-item>
        <e-item v-if='autoConfirmBtn' prefixIcon='icon hero-icon hero-icon-auto-confirm' :tooltipText='$t("Alarm.automaticConfirmation")' :click='notices' eventType='autoConfirm'></e-item>
        <e-item v-if='hiddenBtn' prefixIcon='icon hero-icon hero-icon-business-operation' :tooltipText='$t("Alarm.hidden")' :click='notices' eventType='hidden'></e-item>
        <!-- <e-item v-if='updateBtn' prefixIcon='icon hero-icon hero-icon-upload' :tooltipText='$t("Alarm.alarmUpdate")' :click='notices' eventType='update'></e-item> -->
        <e-item v-if='alarmSyncBtn' prefixIcon='icon hero-icon hero-icon-topo-tcf' :tooltipText='$t("Alarm.alarmSync")' :click='notices' eventType='alarmSync'></e-item>
      </e-items>
    <el-button v-if="printBtn"  class="e-tbar-btn e-control e-btn e-lib e-icon-btn" type="button" v-print="printObj" :title='$t("Alarm.print")'> </el-button> 
    </ejs-toolbar>
    <div v-if="printBtn" class="e-toolbar" >
      <div class="e-toolbar-items" >
        <div class="e-toolbar-item" style="margin-left: -2px;">
          <button  class="e-tbar-btn e-control e-btn e-lib e-icon-btn" type="button" v-print="printObj" :title='$t("Alarm.print")' >
            <span class="e-btn-icon icon hero-icon hero-icon-print e-icons"></span>
          </button>
        </div>
      </div>
    </div>
    <div v-if='keywordsInput' class='h-inputBox'>
      <ejs-textbox v-model='queryConditions.keywords' :placeholder='$t("Alarm.pleaseEnterTheQueryCriteria")' :width="400" clipMode='EllipsisWithTooltip' @input='updateKeywords' @keydown.native.enter='keydownFunc'></ejs-textbox>
    </div>
  </div>
</template>
<script>
export default {
  name: 'currentAlarmButton',
  props: {
    refreshBtn: { type: Boolean, default: false },
    exportBtn: { type: Boolean, default: false },
    syncBtn: { type: Boolean, default: false },
    separatorLine: { type: Boolean, default: false },
    confirmBtn: { type: Boolean, default: false },
    clearBtn: { type: Boolean, default: false },
    showDetailBtn: { type: Boolean, default: false },
    statisticsBtn: { type: Boolean, default: false },
    shieldBtn: { type: Boolean, default: false },
    filterBtn: { type: Boolean, default: false },
    hiddenBtn: { type: Boolean, default: false },
    subscritionBtn: { type: Boolean, default: false },
    autoConfirmBtn: { type: Boolean, default: false },
    keywordsInput: { type: Boolean, default: false },
    printBtn:{type: Boolean, default: false},
    updateBtn:{type: Boolean, default: false},
    alarmSyncBtn:{type: Boolean,default:false}
  },
  data() {
    return {
      isOn: '0',
      isFiltered: false,
      queryConditions: {
        systemId: 1,
        conditions: '', // 告警过滤时会有查询条件，筛调部分告警，初始化时需获取初始条件
        keywords: '', // 模糊查询关键字
      },
      printObj: {
        id: "alarmPageId",//打印区域 Dom ID
        popTitle: 'UNMS',
        extraCss: '',
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>,<style type="text/css" media="print">@page { size: landscape; margin:20px;}</style>,<style type="text/css" media="print">body{ zoom:80%}</style>'  ,
      }
    };
  },
  computed: {
    subscritionIcon() {
      return this.isOn === '1' ? 'icon hero-icon hero-icon-on' : 'icon hero-icon hero-icon-off';
    },
    fiterIcon() {
      return this.isFiltered ? 'icon hero-icon hero-icon-filter' : 'icon hero-icon hero-icon-filter2';
    }
  },
  methods: {
    setFilered(isFilteredBoolValue) {
      this.isFiltered = isFilteredBoolValue;
    },
    windowPrintObj() {
			var newstr = document.getElementById("alarmPageId").innerHTML;
			var oldstr = document.body.innerHTML;
			document.body.innerHTML = newstr;
			document.getElementsByTagName('body')[0].style.zoom=0.8;
			window.print();
			document.body.innerHTML = oldstr;
			document.getElementsByTagName('body')[0].style.zoom=1;
			return false;
    },
    notices(args) {
      if (args.item.eventType === 'refresh') {
        this.queryConditions.keywords = '';
      }
      this.$emit('notice', args.item.eventType);
    },
    getSubscritionStatus() {
      // 刷新告警订阅状态 0:off 1:on
      const This = this;
      This.$axios.post('/lte/ems/fm/alarmcurrent/queryIsOn').then((response) => {
        if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
          This.isOn = `${response.data.resultVal.isOn}`;
          This.$emit('isOn', This.isOn);
        }
      });
    },
    subscritionFunc() {
      // 点击告警订阅
      const This = this;
      This.$axios.post('/lte/ems/fm/alarmcurrent/modifyAutoPara').then((response) => {
        if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
          This.isOn = This.isOn === '1' ? '0' : '1';
          This.$emit('isOn', This.isOn);
          if (This.isOn === '1') {
            This.$emit('notice', 'refresh');
          }
        }
      });
    },
    updateKeywords() {
      this.$emit('keywords', this.queryConditions.keywords);
    },
    keydownFunc() {
      if (this.queryConditions.keywords === '') {
        this.queryConditions.keywords = '';
        this.$emit('notice', 'conditions');
      } else {
        this.$emit('notice', 'keywords');
      }
    }
  },
  mounted() {
    if (this.subscritionBtn) {
      this.getSubscritionStatus();
    }
  }
};
</script>
